"use strict";

var _defineProperty = require("/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0; // ========================= Placeholder ==========================

var genEmptyStyle = function genEmptyStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), _defineProperty({}, "".concat(componentCls, "-tbody > tr").concat(componentCls, "-placeholder"), {
    textAlign: 'center',
    color: token.colorTextDisabled,
    '&:hover > td': {
      background: token.colorBgContainer
    }
  }));
};

var _default = genEmptyStyle;
exports.default = _default;